var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19995 6.99998C4.19995 6.62867 4.34745 6.27258 4.61 6.01003C4.87255 5.74748 5.22865 5.59998 5.59995 5.59998H22.4C22.7713 5.59998 23.1273 5.74748 23.3899 6.01003C23.6525 6.27258 23.8 6.62867 23.8 6.99998C23.8 7.37128 23.6525 7.72737 23.3899 7.98992C23.1273 8.25248 22.7713 8.39998 22.4 8.39998H5.59995C5.22865 8.39998 4.87255 8.25248 4.61 7.98992C4.34745 7.72737 4.19995 7.37128 4.19995 6.99998ZM4.19995 14C4.19995 13.6287 4.34745 13.2726 4.61 13.01C4.87255 12.7475 5.22865 12.6 5.59995 12.6H14C14.3713 12.6 14.7273 12.7475 14.9899 13.01C15.2525 13.2726 15.4 13.6287 15.4 14C15.4 14.3713 15.2525 14.7274 14.9899 14.9899C14.7273 15.2525 14.3713 15.4 14 15.4H5.59995C5.22865 15.4 4.87255 15.2525 4.61 14.9899C4.34745 14.7274 4.19995 14.3713 4.19995 14ZM4.19995 21C4.19995 20.6287 4.34745 20.2726 4.61 20.01C4.87255 19.7475 5.22865 19.6 5.59995 19.6H22.4C22.7713 19.6 23.1273 19.7475 23.3899 20.01C23.6525 20.2726 23.8 20.6287 23.8 21C23.8 21.3713 23.6525 21.7274 23.3899 21.9899C23.1273 22.2525 22.7713 22.4 22.4 22.4H5.59995C5.22865 22.4 4.87255 22.2525 4.61 21.9899C4.34745 21.7274 4.19995 21.3713 4.19995 21Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.a44a36803b887c9e585344bcbb03f5ce.svg";
export { ForwardRef as ReactComponent };